import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetCategoriesResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {CategoryHeader} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {FiltersHeaderLoading} from '../../../features/Filters/FiltersHeader/FiltersHeaderLoading';
import {useFiltersHeaderData} from '../utils/useFiltersHeaderData';
import {useBackPath} from './helpers';

export const BrandShopHeader: React.FC<{renderingPriority?: number}> = ({
  renderingPriority,
  ...viewProps
}) => {
  return (
    <DataFetcher
      request={useFiltersHeaderData()}
      Error={() => null}
      Loading={FiltersHeaderLoading}
      View={FiltersHeaderView}
      viewProps={viewProps}
      renderingPriority={renderingPriority}
    />
  );
};

const FiltersHeaderView: React.FC<GetCategoriesResponse> = props => {
  const backPath = useBackPath(props.parentCategory);
  return (
    <StyledCategoryHeader
      backTarget={backPath}
      centered
      sidePadding
      stickyOnScrollUp={false}
      categoryName={props.title}
      subtitle={props.seoSubline}
    />
  );
};

const StyledCategoryHeader = styled(CategoryHeader)`
  text-align: center;
`;
